import React from 'react';
import { Award, Target, Users, ShieldCheck } from 'lucide-react';

const HIGHLIGHTS = [
  { Icon: Award, title: 'Certified Excellence', text: 'MBA Finance & AMFI registration ensure compliance-led, professional guidance.' },
  { Icon: Target, title: 'Goal-Oriented', text: 'Plans built around your goals — corpus, retirement age, lifestyle, legacy.' },
  { Icon: Users, title: 'Client-First Service', text: 'Long-term relationships over one-time transactions. No pressure selling.' },
  { Icon: ShieldCheck, title: 'Transparent Practices', text: 'Clear fee structure, full disclosure, zero hidden commissions.' }
];

const HighlightCard = ({ Icon, title, text }) => (
  <div style={{ textAlign: 'center', padding: '1.25rem' }}>
    <div
      style={{
        width: '3.25rem',
        height: '3.25rem',
        margin: '0 auto 0.9rem',
        background: 'var(--primary-navy)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--accent-gold)'
      }}
    >
      <Icon size={20} />
    </div>
    <h4 style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--primary-navy)', marginBottom: '0.4rem' }}>
      {title}
    </h4>
    <p className="body-small">{text}</p>
  </div>
);

export const AboutHighlights = () => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(230px, 1fr))',
      gap: '1.5rem',
      marginTop: '3.5rem',
      paddingTop: '2.5rem',
      borderTop: '1px solid var(--gray-200)'
    }}
  >
    {HIGHLIGHTS.map((h) => (
      <HighlightCard key={h.title} {...h} />
    ))}
  </div>
);
